import React from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AppRouteContext } from '../App/app.types';
import { appRoutePaths, getFullAppRoutePath, hasGoBack } from '../Nav/nav.types';

import { AccountCreate } from './AccountCreate';
import { AccountUpdate } from './AccountUpdate';

export const AccountDetailRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar
        title={id === 'new' ? 'Account Create' : 'Account'}
        onBackClicked={() => {
          const locationState = location.state;
          if (hasGoBack(locationState)) {
            navigate(locationState.goBack.url);
          } else {
            navigate(getFullAppRoutePath(appRoutePaths.Account));
          }
        }}
        onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer}
      />
      {id === 'new' ? <AccountCreate /> : <AccountUpdate accountId={id} />}
    </FlexBox>
  );
};
